module.exports = __webpack_public_path__ + "static/media/factory-acceptance-test.cba44619.jpg";